<script>
  export default {
    props: {
      inscricao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        cadastroCompleto: this.inscricao.solicitacaoCursoEventoServico.turma.cadastroCompleto,
        pessoaFisica: !(this.inscricao.documento.length > 16)
      }
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <dl class="col-xs-8">
        <dt>Nome</dt>
        <dd>
          {{ inscricao.nome }}
        </dd>
      </dl>

      <dl class="col-xs-4">
        <dt>Documento</dt>
        <dd>
          {{ inscricao.documento }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-6">
        <dt>Endereço</dt>
        <dd>
          {{ inscricao.endereco }}
        </dd>
      </dl>

      <dl class="col-xs-3">
        <dt>Número</dt>
        <dd>
          {{ inscricao.numero }}
        </dd>
      </dl>

      <dl class="col-xs-3">
        <dt>Complemento</dt>
        <dd>
          {{ inscricao.complemento }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-4">
        <dt>Bairro</dt>
        <dd>
          {{ inscricao.bairro }}
        </dd>
      </dl>

      <dl class="col-xs-5">
        <dt>Cidade</dt>
        <dd>
          {{ inscricao.cidade }}
        </dd>
      </dl>

      <dl class="col-xs-3">
        <dt>Estado</dt>
        <dd>
          {{ inscricao.uf }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl :class="[pessoaFisica ? 'col-xs-3' : 'col-xs-4']">
        <dt>CEP</dt>
        <dd>
          {{ inscricao.cep }}
        </dd>
      </dl>

      <dl :class="[pessoaFisica ? 'col-xs-3' : 'col-xs-4']">
        <dt>Telefone</dt>
        <dd>
          {{ inscricao.telefone }}
        </dd>
      </dl>

      <dl :class="[pessoaFisica ? 'col-xs-3' : 'col-xs-4']">
        <dt>Celular</dt>
        <dd>
          {{ inscricao.celular }}
        </dd>
      </dl>

      <dl class="col-xs-3" v-if="pessoaFisica">
        <dt>Data de nascimento</dt>
        <dd>
          {{ inscricao.dataNascimento }}
        </dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-12">
        <dt>Email</dt>
        <dd>
          {{ inscricao.email }}
        </dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-8" v-if="inscricao.faixaValores">
        <dt>Categoria de inscrição</dt>
        <dd>
          {{ inscricao.faixaValores }}
        </dd>
      </dl>

      <dl class="col-xs-8" v-if="!inscricao.faixaValores">
        <dt></dt>
        <dd></dd>
      </dl>

      <dl class="col-xs-3">
        <dt>Valor</dt>
        <dd>
          {{ inscricao.valor | formatarNumero }}
        </dd>
      </dl>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-matricular/componentes/compartilhado/FormDadosInscricaoPF.vue